// Translation table between the action slugs the `/guardian-modules` API
// returns (uppercase, e.g. `VIEW`, `EDIT`) and the permission values the
// `/guardian-roles` API stores (lowercase, e.g. `view`, `update`).
//
// `view` is the canonical spelling of the "view" capability — it matches the
// `VIEW` action slug the modules API returns and the value the backend
// persists in `customer_guardian_role_permissions.permission`.
//
// `read` is the legacy alias: roles authored before the switch still carry
// it, so it stays *readable* (see `PERMISSION_TO_ACTION_SLUG` below) — but it
// is never written any more.
const ACTION_SLUG_TO_PERMISSION = {
  CREATE: 'create',
  READ: 'view',
  VIEW: 'view',
  // The API returns the "Edit" action with the slug `EDIT` (mirroring how
  // the modal's within-row dependency rules key it — see
  // `ACTION_REQUIRES.EDIT` / `REQUIRED_BY` in AddRoleModal.jsx), so the
  // forward-mapping table has to resolve both spellings to the canonical
  // `'update'` permission the backend stores. Without this entry,
  // `buildPermissionsPayload` looked up `EDIT`, got `undefined`, and
  // silently dropped every Edit permission from the payload — leaving
  // roles that visually checked "Edit" in the UI but stored only
  // create / view / delete. Add any future spellings here too.
  UPDATE: 'update',
  EDIT: 'update',
  DELETE: 'delete',
  UPLOAD: 'upload',
}

const PERMISSION_TO_ACTION_SLUG = {
  ...Object.fromEntries(
    Object.entries(ACTION_SLUG_TO_PERMISSION).map(([slug, permission]) => [
      permission,
      permission === 'view' ? 'VIEW' : permission === 'update' ? 'EDIT' : slug,
    ])
  ),
  // Legacy alias — roles authored before the `read` → `view` switch still
  // carry `read`, so the modal has to be able to resolve it back to the
  // `VIEW` action and tick the right box when the role is opened for edit.
  read: 'VIEW',
}

export { ACTION_SLUG_TO_PERMISSION, PERMISSION_TO_ACTION_SLUG }
